import { createApiClient } from "@nimit9/signet-lib/api"

/**
 * paisa's API client: Signet's createApiClient against the same-origin /api
 * proxy with the session cookie. A 401 throws AuthError (query-client.ts turns
 * that into a redirect to /login); any other non-2xx throws ApiError.
 *
 * Lives apart from `./api` so tests can exercise the real client — many test
 * files mock.module("@/lib/api"), and bun module mocks are process-global.
 */
export function createPaisaApi() {
  return createApiClient({ baseUrl: "/api", credentials: "include" })
}
